import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Interface } from 'readline';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/services/data/data.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-widget-one',
  templateUrl: './widget-one.component.html',
  styleUrls: ['./widget-one.component.sass'],
})
export class WidgetOneComponent implements OnInit, OnDestroy {
  @Input() data: SeverityData[];

  currLoc: any;
  unsub$: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private dataService: DataService,
    private locationStore: LocationStoreService
  ) {}

  ngOnInit(): void {
    this.locationStore.currLocation$
      .pipe(takeUntil(this.unsub$.asObservable()))
      .subscribe((res) => {
        this.currLoc = res;
      });
  }

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.unsubscribe();
  }

  openSummaryModal(): void {
    if (!this.currLoc?.id) return;

    const children = this.currLoc?.children;
    if (children?.length)
      this.router.navigate([
        `projects/${this.currLoc.id}/details/modal/${this.currLoc?.children[0].id}`,
      ]);
  }
}

export interface SeverityData {
  severity_level: string;
  name?: string;
  value: number;
  color: string;
}
